import React from "react";
//#region types
import { AddressProps } from "models/propTypes/commonPropTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
//#endregion

const Address: React.FC<AddressProps> = (props) => {
  return (
    <Grid container>
      {props.street1 && <Grid container>{props.street1}</Grid>}
      {props.street2 && <Grid container>{props.street2}</Grid>}
      <Grid container spacing={1}>
        {props.zipCode && <Grid item>{props.zipCode}</Grid>} {props.city && <Grid item>{props.city}</Grid>}
      </Grid>
      {props.country && <Grid container>{props.country}</Grid>}
    </Grid>
  );
};

export default Address;
